<template>
  <form-field
    class="c-form-field-row"
    is-row
    :model-value="modelValue"
    :field-schema="rowSchema"
    :field-name="fieldName"
    :form-schema="formSchema"
    :form-value="formValue"
    :has-row-labels="hasRowLabels"
    :style="{ '--rows': fieldSchema.schemas.length }"
    v-bind="fieldAttrs"
    @list:add="$emit('list:add')"
    @list:remove="$emit('list:remove')"
  >
    <form-field
      v-for="(schema, i) in fieldSchema.schemas"
      ref="fields"
      :key="`${schema.label}-${i}`"
      :field-schema="schema"
      :form-schema="formSchema"
      :model-value="modelValue[i]"
      :form-value="formValue"
      :field-name="`${fieldName}-${i}`"
      :validation-field-name="`${fieldName}-${i}`"
      :field-options="getOptions(schema, `${fieldName}-${i}`)"
      :has-validation="hasValidation"
      @update:modelValue="onInputItem($event, i)"
      @pre-validate="$emit('pre-validate')"
    />

    <c-divider v-if="!(rowSchema || {}).disableDivider" />
  </form-field>
</template>

<script>
import CDivider from '@convenia/components/CDivider'
import SubmitFormat from '../mixins/SubmitFormat'
import FormField from './FormField.next.vue'

export default {
  name: 'CFormBuilderFormFieldRow',

  inheritAttrs: false,

  mixins: [ SubmitFormat({ schemaRef: 'fieldSchema', childRefsName: 'fields' }) ],

  components: {
    FormField,
    CDivider
  },

  props: {
    fieldSchema: {
      type: Object,
      default: () => ({}),
    },

    fieldName: {
      type: String,
      default: '',
    },

    fieldOptions: {
      type: Array,
      default: () => [],
    },

    formSchema: {
      type: Object,
      default: () => ({}),
    },

    hasValidation: Boolean,

    hasRowLabels: Boolean,

    formValue: {
      type: Object,
      default: () => ({}),
    },

    modelValue: {
      required: true,
      validator: () => true
    },

    rowFieldOptions: {
      type: Object,
      default: () => ({})
    },
  },

  emits: [
    'update:modelValue',
    'list:add',
    'list:remove',
    'pre-validate',
  ],

  computed: {
    value () {
      return this.modelValue
    },

    fieldAttrs () {
      return Object.entries(this.$attrs || {}).reduce((acc, [ key, value ]) => {
        if (!key.startsWith('on')) acc[key] = value

        return acc
      }, {})
    },

    rowSchema () {
      return {
        ...this.fieldSchema,
        type: 'slot',
      }
    }
  },

  methods: {
    onInputItem (newItemValue, index) {
      const newValue = [ ...this.modelValue ]
      newValue[index] = newItemValue
      this.$emit('update:modelValue', newValue)
    },

    getOptions (schema, fieldName) {
      return this.rowFieldOptions[schema?.optionsSrc || fieldName] || []
    }
  }
}
</script>

<style lang="scss" src="./styles/FormFieldRow.shared.scss"></style>
